import { render } from "./addInformation.vue?vue&type=template&id=f14a4410&scoped=true"
import script from "./addInformation.vue?vue&type=script&lang=js"
export * from "./addInformation.vue?vue&type=script&lang=js"

import "./addInformation.vue?vue&type=style&index=0&id=f14a4410&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f14a4410"]])

export default __exports__